import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './dicionarioForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista } from './dicionarioActions';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import imagemFundo from '../assets/images/dicionario/fundo.png';

class Dicionario extends Component {

	state = {
		letraSelecionada: 'A'
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
    }

    render() {

		let listaLetra = [];
		this.props.lista.forEach(item => {
			if (!listaLetra.includes(item.palavra.substring(0, 1).toUpperCase())) {
				listaLetra.push(item.palavra.substring(0, 1).toUpperCase());
			}
		});
		listaLetra.sort();

        return (
			<>
				<div 
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						flexWrap: 'wrap',
						backgroundColor: '#0F2748',
						width: '100%',
						padding: 16
					}}>
					{listaLetra.map(item => (
						<button 
							key={item}
							type='button' 
							class='btn btn-block btn-secondary btn-lg' 
							style={{ 
								width: 40, 
								height: 40,
								margin: 1, 
								padding: 0,
								backgroundColor: this.state.letraSelecionada == item ? '#7163aa' : '#0F2748',
								color: this.state.letraSelecionada == item ? '#ffffff' : '#7163aa'
							}}
							onClick={() => this.setState({ ...this.state, letraSelecionada: item })}>
							{item}
						</button>
					))}
					
				</div>
				<Background 
					imagem={imagemFundo}
					backgroundPosition={'bottom 100px'}
					gradientStart='#0F2748'
					gradientEnd='#0F2748'>
					<Content>
						<Aguardando aguardando={this.props.aguardando} />

						{this.props.modoTela == 'cadastro' ? (
							<Form onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'visualizacao' ? (
							<Form visualizacao onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'exclusao' ? (
							<Form excluir onSubmit={this.props.excluir} />
						) : null}
						{this.props.modoTela == 'lista' ? this.lista() : null}
					</Content>
				</Background>
			</>
        )
    }

	lista() {

		let lista = this.props.lista.filter(item => {
			return item.palavra.substring(0, 1).toUpperCase() == this.state.letraSelecionada;
		});

		return (
			<Row alignCenter>
				{this.props.sessao.administrador &&
				<Grid cols='12 6 4 3'>
					<Button
						text='Adicionar'
						type={'primary'}
						icon={'fa fa-plus'}
						event={() => {
							this.props.setModoTela('cadastro', {});
							this.props.initForm({});
						}} />
				</Grid>}

				<Grid cols='12 12 12 12'>
					<div style={{ textAlign: 'center', fontWeight: 'bold', color: '#19CCCC', fontSize: 22, marginBottom: 10 }}>GLOSSÁRIO</div>
				</Grid>
				<Grid cols='12 12 12 10'>
					{lista.map(item => (
						<div key={item.id}
							style={{
								marginTop: 20,
								backgroundColor: '#0F2748',
								color: '#ffffff',
								borderRadius: 20,
    							boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
								opacity: '90%'
							}}>
							<div style={{ width: 'fit-content', fontSize: 22, fontWeight: 'bold', padding: 8 }}>
								{item.palavra}

								{this.props.sessao.administrador &&
								<ButtonTable
									type={'primary'}
									icon={'fas fa-pencil-alt'}
									visible={true}
									event={() => {
										this.props.setModoTela('cadastro', {
											...item
										});
										this.props.initForm({
											...item
										});
									}} />}

								{this.props.sessao.administrador &&
								<ButtonTable
									type={'danger'}
									icon={'fas fa-trash'}
									visible={true}
									event={() => {
										this.props.setModoTela('exclusao', {
											...item
										});
										this.props.initForm({
											...item
										});
									}} />}
							</div>

							<div style={{ fontSize: 18, padding: 4, marginTop: 8 }}>
								{(item.descricao || '').split('\n').map(linha => <p key={linha} style={{ padding: 0}}>{linha}</p>)}
							</div>							
						</div>
					))}
				</Grid>
			</Row>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.dicionario.modoTela,
	aguardando: state.dicionario.aguardando,
	lista: state.dicionario.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Dicionario);
